










import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import SubmitButton from "@/components/Form/elements/SubmitButton.vue";
import Input from "@/components/Form/elements/Input.vue";
import ITimeTrackingCustomer from "@/models/TimeTracking/ITimeTrackingCustomer";

@Component({
  components: {SubmitButton, Input}
})
export default class Form extends Vue {
  public name: string = "Form";

  @Prop({required: false, default: null})
  public item?: ITimeTrackingCustomer;

  @Watch('item', {immediate: true, deep: true})
  private onItemChanged(customer?: ITimeTrackingCustomer) {
    // removed console_log
    if (customer) {

      this.cname = customer.name;

    }

  }

  private cname: string = '';

  private get values(): any {

    return {
      name: this.cname,
    };

  }

  private onSubmit(): void {

    this.$emit('submit', this.values);

  }


}
